// 수량 비교
export const RESULT_SMALL = 0; // 작다
export const RESULT_BIG = 2; // 크다
export const RESULT_SAME = 1; // 같다
